import React from 'react';

const PastoralVisitNotActive = () => {
  return (
    <div>
      <p>
        Parafia obecnie nie prowadzi zapisów na wizyty duszpasterskie. Skontaktuj się z kancelarią
        parafialną w sprawie szczegółów.
      </p>
    </div>
  );
};

export default PastoralVisitNotActive;
